import { PropsWithChildren } from "react";

export interface ContainerProps {
  className?: string;
}

export function Container(props: PropsWithChildren<ContainerProps>) {
  return <div className={`max-w-7xl mx-auto px-4 md:px-10 ${props.className ?? ""}`}>{props.children}</div>;
}
